// app/models/views/sitevisit-tracker.ts
import { PublicViewTracker, ViewTracker } from './viewtracker';
import { lastValueFrom } from 'rxjs';
import { EventType, StatisticsService } from 'src/app/services/statistics.service';

export class SiteVisitTracker extends ViewTracker implements publicSiteVisitTracker {
  private timeStamp: string | null = null;

  constructor(private stats: StatisticsService, rehydratedUuid?: string, rehydratedTimeStamp?: string) {
    super('SiteVisit');

    // rehidratación (no genera uuid nuevo)
    if (rehydratedUuid && rehydratedTimeStamp) {
      this.viewUuid = rehydratedUuid;
      this.siteVisitUuid = rehydratedUuid;
      this.timeStamp = rehydratedTimeStamp;
      this.isOpen = true;
    }
  }

  protected override reset(): void {
    super.reset();
    this.timeStamp = null;
  }

  public getTimeStamp(): string | null {
    return this.timeStamp;
  }

  // siteVisitUuid = su propio uuid
  protected override onOpenContext(body: any): void {
    this.siteVisitUuid = this.viewUuid;
    this.timeStamp = new Date().toISOString();
  }

  protected async create(body: any): Promise<void> {
    await lastValueFrom(this.stats.sendAnalyticsEvent({
      eventType: EventType.SiteVisitNew,
      properties: {
        siteVisitUuid: this.viewUuid,
        // SOLO AQUÍ
        applicationId: 2,
      }
    }));
  }

  protected ping(): void {
    lastValueFrom(this.stats.sendAnalyticsEvent({
      eventType: EventType.SiteVisitPing,
      properties: { siteVisitUuid: this.viewUuid }
    })).catch();
  }

  protected async closeApi(): Promise<void> {
    await lastValueFrom(this.stats.sendAnalyticsEvent({
      eventType: EventType.SiteVisitExit,
      properties: { siteVisitUuid: this.viewUuid }
    }));
  }

  protected async startApi(): Promise<void> { return; }
  protected async finishApi(): Promise<void> { return; }
}

export interface publicSiteVisitTracker extends PublicViewTracker {
  getTimeStamp(): string | null;
}
